<script setup lang="ts">
import { useUserStore } from '@/store/user'

const userStore = useUserStore()
const userInfo = computed(() => userStore.userInfo)

onMounted(() => {
  userStore.loadUserInfo()
})
</script>

<template>
  <!-- 配置参考：https://element-plus.org/zh-CN/component/config-provider -->
  <el-config-provider
    :card="{ shadow: 'never' }"
    :message="{ max: 1, plain: true }"
    :table="{ showOverflowTooltip: true, tooltipEffect: 'dark' }"
    :dialog="{ draggable: true }"
  >
    <el-watermark :content="['智通平台B端', userInfo?.nickname || '']" class="h-full w-full">
      <router-view />
    </el-watermark>
  </el-config-provider>
</template>
